<div class="header bg-danger pb-6">
  <div class="container-fluid">
    <div class="header-body">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <xng-breadcrumb [separator]="iconTemplate">
              <ng-container *xngBreadcrumbItem="
              let breadcrumb;
              let info = info;
              let first = first
            ">
              @if (first) {
                <div class="h3 text-white d-inline-block mb-0" [routerLink]="routeParent">
                  @if (info) {
                    <i [class]="info"> </i>
                  }
                  {{ breadcrumb }}
                </div>
              }
              @if (!first) {
                <div class="h4 text-white d-inline-block mb-0" [routerLink]="routeChild">
                  {{ breadcrumb }}
                </div>
              }
            </ng-container>
          </xng-breadcrumb>
          <ng-template #iconTemplate>
            <i class="fas fa-caret-right text-secondary breadcrumb-item active mt-1"></i>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>